/** The one waiting-time collector of the kitchen screen (feature 334, US3). */
import { clientMetricsApi } from "../../api/client-metrics";
import { createMetrics } from "./metrics";

export const kitchenMetrics = createMetrics({ send: (report) => clientMetricsApi.send(report) });
